import { MenuItem } from "@mui/material"
import { useEffect } from "react"
import { Controller, useForm } from "react-hook-form"
import DropZone from "../../Common/DropZone/DropZone"
import CustomButton from "../../UI/CustomButton/CustomButton"
import Field from "../../UI/Field/Field"
import CustomSelect from "../../UI/Form/Select"
import Modal from "../../UI/Modal/Modal"
import classes from '../AdminForm.module.css'

const SlideUpdate = (props) => {
    const { onClose, editSlide, slide } = props

    const { handleSubmit, control, reset } = useForm()

    const onSubmit = (data) => {
        editSlide(slide._id, data)
    }

    useEffect(() => {
        reset({
            ...slide,
            bg: [slide.bg],
            images: slide.images
        })
    }, [])

    return (
        <Modal title="Нова конструкція" onClose={onClose}>
            <form className={classes.main} onSubmit={handleSubmit(onSubmit)}>
                <Field>
                    <Controller
                        name="type"
                        control={control}
                        rules={{ required: "Обов'язкове поле!" }}
                        defaultValue=""
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <CustomSelect
                                onChange={onChange}
                                value={value}
                                error={error}
                                label="Тип"
                            >
                                <MenuItem value="karp">Карпорти</MenuItem>
                                <MenuItem value="terrace">Тераси</MenuItem>
                            </CustomSelect>
                        )}
                    />
                </Field>
                <div className={classes.imgContainer}>
                    <Controller
                        name={`bg`}
                        control={control}
                        rules={{ required: "Обов'язкове поле!" }}
                        defaultValue=""
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <DropZone
                                onChange={onChange}
                                error={error}
                                title="Бекграунд"
                                id={1}
                                initialFiles={value}
                            />
                        )}
                    />
                </div>
                <div className={classes.imgContainer}>
                    <Controller
                        name={`images`}
                        control={control}
                        rules={{ required: "Обов'язкове поле!" }}
                        defaultValue=""
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <DropZone
                                onChange={onChange}
                                error={error}
                                title="Зображення"
                                multiple={true}
                                initialFiles={value}
                                id={2}
                            />
                        )}
                    />
                </div>
                <CustomButton type="submit">Зберегти</CustomButton>
                <Field></Field>
            </form>
        </Modal>
    )
}

export default SlideUpdate